import { GetServerSideProps } from 'next';

import { Header } from '../common/header';
import { getServerSideHelper } from '../src/services/utilities';
import { HomePageProps } from '../src/api/models/venue';
import { HomePage } from '../src/pages/HomePage/HomePage';
import { Layout } from '../src/common/components/Layout/Layout';
import { AuthHandler } from '../src/common/components/AuthHandler/AuthHandler';
import { ExpiredLinkScreen } from '../src/pages/HomePage/DeactivatedScreen';


const Home = (props: HomePageProps) => {
  // Deactivated account: render the static screen without AuthHandler/HomePage
  // so no upload flow hooks mount (speed test, campaign fetches, animations)
  // and no tracking events fire.
  if (props.accountActive === false) {
    return (
      <>
        <Header {...props} />
        <Layout>
          <ExpiredLinkScreen />
        </Layout>
      </>
    );
  }

  return (
    <>
      <Header {...props} />
      <Layout>
        <AuthHandler>
          <HomePage />
        </AuthHandler>
      </Layout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { props } = (await getServerSideHelper(context)) as any;

  return {
    props: { ...props },
  };
};

export default Home;
